import React, { useCallback, useState } from "react";
import ContentLoader from "react-content-loader";

const GenreListLoaderTemplate = (props) => {
    const [loaderWidth, setLoaderWidth] = useState(0);

    const ref = useCallback((node) => {
        if (node !== null) setLoaderWidth(node.getBoundingClientRect().width);
    }, []);

    const loaderList = [];
    let y = 0;

    for (let i = 0; i < 10; i++) {
        loaderList.push(
            <React.Fragment>
                <rect x="0%" y={y} rx="0" ry="0" width="48" height="48" />
                <rect x="9%" y={y + 6} rx="6" ry="6" width="220" height="12" />
                <rect x="9%" y={y + 28} rx="6" ry="6" width="80" height="10" />
                <rect x={loaderWidth - 94} y={y + 4} rx="8" ry="8" width="16" height="16" />
                <rect x={loaderWidth - 70} y={y + 6} rx="6" ry="6" width="70" height="12" />
                <rect x={0} y={y + 60} rx="6" ry="6" width="100%" height="1" />
            </React.Fragment>
        );

        y += 74;
    }

    return (
        <div ref={ref}>
            <ContentLoader
                speed={2}
                width="100%"
                height={loaderList.length * 72}
                viewBox={`0 0 ${loaderWidth} ${loaderList.length * 72}`}
                backgroundColor="#262729"
                foregroundColor="#2b2b2b"
                {...props}
            >
                {loaderList}
            </ContentLoader>
        </div>
    );
};

export default GenreListLoaderTemplate;
